export default __webpack_public_path__ + "static/media/deekshitha.f843bb69.jpg";